export function generateSectionSchema(columns, config, additionalConfig) {
  const { inlineData, colSpan, topAlign, headerOnly, headerSize } = config || {};
  const totalColSpan = colSpan || columns.length;

  function generateAccessor(columnName) {
    const sanitizedColumnName = columnName.replace(/[^a-zA-Z0-9]/g, "");
    return sanitizedColumnName.replace(/([A-Z])/g, (match, group1) => group1.toLowerCase());
  }

  function generateColumnSchema(column, index) {
    const adjustedColSpan = Math.floor(totalColSpan / columns.length);
    const remainingColSpan = totalColSpan % columns.length;

    return {
      title: column.title ? column.title : column,
      colSpan: adjustedColSpan + (index === columns.length - 1 ? remainingColSpan : 0),
      rowSpan: 1,
      leftAlign: inlineData && true,
      topAlign: topAlign && true,
      className: "tbl-text-normal",
      accessor: column.accessor ? column.accessor : generateAccessor(column),
      ...additionalConfig,
      ...(column && column.configs),
    };
  }

  const sectionSchema = {
    heights: {
      header1: headerSize ? headerSize : "75px",
    },
    headerOnly: headerOnly,
    classes: {
      header1: headerOnly ? "grey-background" : "",
    },
    minDataRowsCount: inlineData ? undefined : 1,
    inlineData: inlineData,
    columns: columns.map(generateColumnSchema),
  };

  return sectionSchema;
}

export function generateIdFieldNamePairs(schema) {
  const idFieldNamePairs = [];

  // Iterate through sections in the schema
  schema.sections.forEach((section) => {
    // Check if the section has a 'columns' property
    if (section.columns) {
      // Iterate through columns in the section
      section.columns.forEach((column) => {
        // Extract 'accessor' and 'title' from each column
        const id = column.accessor;
        const fieldName = column.title;

        // Push the id and fieldName pair to the result array
        idFieldNamePairs.push({ id, fieldName });
      });
    }
  });

  return idFieldNamePairs;
}



// WEBPACK FOOTER //
// ./src/libraries/ReportGenerator/SchemaHelpers/SchemaHelpers.js